import { useId } from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getScheduleEndDate } from 'src/utils/recurring';

// Keep the existing API distinction inside the form: recurring has a cutoff,
// indefinite repeats without one. Both appear as a repeating donation.
export default function DonationScheduleEnd({ data, onChange }) {
  const { t } = useTranslation('translation');
  const labelId = useId();
  return (
    <FormControl sx={{ my: 2 }}>
      <FormLabel id={labelId}>{t('donations.schedule-ends')}</FormLabel>
      <RadioGroup
        aria-labelledby={labelId}
        row
        value={data.occurrenceType}
        onChange={(event) => {
          const occurrenceType = event.target.value;
          onChange({
            occurrenceType,
            endDate: getScheduleEndDate({ ...data, occurrenceType }),
          });
        }}
      >
        <FormControlLabel
          value="indefinite"
          control={<Radio />}
          label={t('donations.no-end-date')}
        />
        <FormControlLabel
          value="recurring"
          control={<Radio />}
          label={t('donations.ends-on-date')}
        />
      </RadioGroup>
      {data.occurrenceType === 'indefinite' && (
        <FormHelperText>{t('donations.no-end-date-help')}</FormHelperText>
      )}
    </FormControl>
  );
}
